import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const agentStudioConversationReviewRoute: InvariantRoute = {
	name: 'agent-studio-conversation-review',
	path: '/jira/support-center/settings/agent-studio/review/:conversationId?',
	exact: true,
};
